const anchorManage = resolve => require(['@/pages/anchorManage/anchorMsg/index.vue'], resolve)
export default[
    //智能屏管理
    {
      path: "/anchorManage",
      name: "主播信息管理",
      component: anchorManage
    }
]